import { createRoutine } from 'app/common/utils/new-routines';
import { type ActionType, createAction } from 'typesafe-actions';
import type { User, UserId } from './types.js';

export type ChannelInfo = {
  projectId: string;
  contentId?: string;
};

export type ChannelPayload = {
  channelInfo: ChannelInfo;
};

export const userEntered = createAction('collab/USER_ENTERED')<{ user: User } & ChannelPayload>();
export const userLeft = createAction('collab/USER_LEFT')<{ user: User } & ChannelPayload>();
export const initUsers = createAction('collab/INIT_USERS')<{ users: Record<UserId, User> } & ChannelPayload>();
export const userMovedToContent = createAction('collab/USER_MOVED_TO_CONTENT')<{
  contentId: string;
  userId: UserId;
  hasLock?: boolean;
}>();
export const userMovedFromContent = createAction('collab/USER_MOVED_FROM_CONTENT')<{
  contentId: string;
  userId: UserId;
}>();

export type GetCollabUsersRequested = {
  projectId: string;
};

export type GetCollabUsersPayload = {
  members: Array<{
    userId: string;
    contentList: Array<{
      contentId: string;
      shapeId: string;
      hasLock: boolean;
    }>;
  }>;
};

export const getCollabUsers = createRoutine('collab/GET_COLLAB_USERS')<
  undefined,
  GetCollabUsersRequested,
  undefined,
  GetCollabUsersPayload,
  undefined,
  undefined
>();

export type Actions =
  | ActionType<typeof initUsers>
  | ActionType<typeof userEntered>
  | ActionType<typeof userLeft>
  | ActionType<typeof userMovedToContent>
  | ActionType<typeof userMovedFromContent>
  | ActionType<typeof getCollabUsers.fulfilled>;
